import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useProfileEnrichments } from './enrichments/useProfileEnrichments';

export const useSessionUser = () => useSelector(state => state.session.user);

export const useMyUserId = () => useSelector(state => state.session.user?.id);

export const useMyAccount = () => useSelector(state => state.session.user);

export const useMyAccountAsParticipant = eventId => {
    const user = useMyAccount(),
        profileEnrichments = useProfileEnrichments(eventId);
    return useMemo(() => {
        return {
            ...user,
            extra_profile_data: profileEnrichments
                .map(q => ({
                    uv: true,
                    type: 'enrichment',
                    name: q.question.text,
                    value: (q.answer || []).map(answer => {
                        if (q.question.answer_type == 'options') {
                            return (q.question.options.find(option => option.value == q.answer) || {}).label;
                        }
                        return answer;
                    }),
                }))
                .filter(item => item.value.length),
        };
    }, [user, profileEnrichments]);
};

export const usePrefillData = () => useSelector(state => state.session.prefill);

export const useLastUpdate = () => useSelector(state => state.session.lastUpdate);

export const useHasAPIConnection = () => useSelector(state => state.session.hasAPIConnection);
